import React from "react";

function PageLoading() {
	
	//[오류] 과제 선택 시 로딩 안되는 오류 발생
	// 로딩 후 5초가 지나면 자동으로 사라지게 처리 
	// $(document).ready(function(){
	// 	setTimeout(hide_panel, 4000);
	// 	function hide_panel(){
	// 		$(".loading").fadeOut('slow');
	// 	}
	// });
	   
	return (
		<div className="loading">
			<div className="loader"></div>
		</div>
	);
}

export default PageLoading;